/* 真实用户字段观测：PV + Core Web Vitals（TTFB/LCP/CLS/INP，web-vitals 官方库）→ POST /api/vitals（docs/plan-r504）。
   页面隐藏/离开时一次性 sendBeacon；每个指标每次页面浏览只上报一次（bfcache 恢复视为新浏览）；无 Cookie、无用户标识；
   导航离开时 pagehide 先于 visibilitychange（web-vitals 在后者结算 LCP/CLS/INP），故各指标 reportAllChanges 随时更新待发终值，pagehide 一条发全（docs/plan-r622）；
   beacon 须绕过 SW fetch 事件（public/sw.js 把 /api/* 静态路由到网络，否则卸载时被丢弃）；
   QA/自动化（webdriver 或 tiku-qa=1）带 qa:true 由服务端短路不入库。esbuild bundle:true 打包为 /vitals.js?v=N（src/layout.ts VITALS_VER）。 */
import { onCLS, onINP, onLCP, onTTFB } from 'web-vitals';

var pending = {};
var sent = {};

function isQa() {
  try { return navigator.webdriver === true || localStorage.getItem('tiku-qa') === '1'; } catch (_) { return navigator.webdriver === true; }
}

function enqueue(n, v, r, t) {
  if (sent[n]) return;
  pending[n] = { n: n, v: v, r: r, t: t || '' };
}

function navType() {
  try { var e = performance.getEntriesByType('navigation')[0]; return e && e.type ? e.type.replace('_', '-') : 'navigate'; } catch (_) { return 'navigate'; }
}

function push(m) {
  enqueue(m.name, Math.round(m.name === 'CLS' ? m.value * 1000 : m.value), m.rating, m.navigationType);
}

function flush() {
  var names = Object.keys(pending);
  if (!names.length) return;
  var m = names.slice(0, 8).map(function (n) { sent[n] = 1; return pending[n]; });
  pending = {};
  var body = JSON.stringify({
    p: location.pathname.slice(0, 200),
    ver: document.documentElement.dataset.ver || '',
    w: window.innerWidth | 0,
    qa: isQa(),
    m: m
  });
  var ok = false;
  try { ok = !!(navigator.sendBeacon && navigator.sendBeacon('/api/vitals', new Blob([body], { type: 'application/json' }))); } catch (_) { ok = false; }
  if (!ok) fetch('/api/vitals', { method: 'POST', body: body, headers: { 'Content-Type': 'application/json' }, keepalive: true }).catch(function () {});
}

enqueue('PV', 1, '', navType());
onTTFB(push);
onLCP(push, { reportAllChanges: true });
onCLS(push, { reportAllChanges: true });
onINP(push, { reportAllChanges: true });

/* 切标签/后台：web-vitals 以 capture 阶段监听 visibilitychange 先结算并回调，此处（冒泡阶段）一次上报；
   导航离开：pagehide 先发（pending 已是 reportAllChanges 终值），随后 visibilitychange 无新增不再发 */
addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
addEventListener('pagehide', flush);
/* bfcache 恢复：web-vitals 会按新页面浏览重新上报各指标，这里同步重置去重表并计一次 PV；
   app.js（文档序更早的 defer，监听先触发）判定本机状态已变而立即 reload 时置 html[data-bfr]，此次恢复不计 PV，由随后的 reload 按 navigate 计 */
addEventListener('pageshow', function (e) { if (e.persisted && !document.documentElement.dataset.bfr) { sent = {}; pending = {}; enqueue('PV', 1, '', 'back-forward-cache'); } });
